<button
  mat-icon-button
  [attr.type]="buttonType()"
  (click)="clickButton()"
  [attr.id]="buttonId()"
  [title]="ariaLabel()"
  [attr.aria-label]="ariaLabel()"
  [disabled]="isDisabled()"
  [color]="buttonStyle() === 'grey' ? undefined : buttonStyle()"
  [class.grey-button]="buttonStyle() === 'grey'"
  [class.negative-button]="buttonStyle() === 'negative'"
  [class.dark-blue-button]="buttonStyle() === 'dark-blue'"
  [class.selected-button]="buttonStyle() === 'selected'"
>
  <mat-icon>{{ iconName() }}</mat-icon>
</button>
